import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getLineHeightOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { createButtonBlock } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/createButtonBlock";
import { defaultData as defaultH2Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H2Block/H2BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HeroBlock5",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Heading",
          baseData: defaultH2Data,
          styles: {
            fontSize: getFontSizeOptions("40px"),
            lineHeight: getLineHeightOptions("1.2"),
            color: getColorOptions("var(--theme-email-color-1)"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "20",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
          baseData: defaultPData,
          styles: {
            fontSize: getFontSizeOptions("16px"),
            lineHeight: getLineHeightOptions("1.5"),
            color: getColorOptions("var(--theme-email-color-1)"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
      ],
    },
    primaryButton: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Button",
          href: "#",
          buttonType: "primaryButton",
          align: "left",
          styles: {
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
